import { DemoIcon, DistributionIcon, MaintenanceIcon, PaidIcon, TimeIcon, TtLogoIcon } from 'tombac-icons';
import { ContractAccessType, ContractReportAccessType } from "../contractTypes";
import { jsx as _jsx } from "react/jsx-runtime";
const iconMap = {
  [ContractAccessType.Custom]: MaintenanceIcon,
  [ContractAccessType.Demo]: DemoIcon,
  [ContractAccessType.Evaluation]: TimeIcon,
  [ContractAccessType.Internal]: TtLogoIcon,
  [ContractAccessType.Paid]: PaidIcon,
  [ContractAccessType.Distribution]: DistributionIcon
};
const iconMapReport = {
  [ContractReportAccessType.Custom]: MaintenanceIcon,
  [ContractReportAccessType.Demo]: DemoIcon,
  [ContractReportAccessType.Evaluation]: TimeIcon,
  [ContractReportAccessType.Internal]: TtLogoIcon,
  [ContractReportAccessType.Paying]: PaidIcon,
  [ContractReportAccessType.Distribution]: DistributionIcon
};
export function getContractAccessTypeIcon(access) {
  return iconMap[access];
}
export function getContractReportAccessTypeIcon(access) {
  return iconMapReport[access];
}
export const ContractAccessTypeIcon = _ref => {
  let {
    accessType,
    ...iconProps
  } = _ref;
  const Icon = getContractAccessTypeIcon(accessType);
  return /*#__PURE__*/_jsx(Icon, {
    ...iconProps,
    "data-sentry-element": "Icon",
    "data-sentry-component": "ContractAccessTypeIcon",
    "data-sentry-source-file": "ContractAccessTypeIcon.tsx"
  });
};
export const ContractReportAccessTypeIcon = _ref2 => {
  let {
    accessType,
    ...iconProps
  } = _ref2;
  const Icon = getContractReportAccessTypeIcon(accessType);
  return /*#__PURE__*/_jsx(Icon, {
    ...iconProps,
    "data-sentry-element": "Icon",
    "data-sentry-component": "ContractReportAccessTypeIcon",
    "data-sentry-source-file": "ContractAccessTypeIcon.tsx"
  });
};